<template>
  <div class="nowrap auction-role-container">
    <div v-if="auction.role === auctionRoles.ENTRY.value">
      <v-icon color="grey">lens</v-icon> {{ auctionRoles.ENTRY.label }}
    </div>
    <div v-else-if="auction.role === auctionRoles.APPLICANT.value">
      <v-icon color="blue">lens</v-icon> {{ auctionRoles.APPLICANT.label }}
    </div>
    <div v-else-if="auction.role === auctionRoles.BUYER.value">
      <v-icon color="green">lens</v-icon> {{ auctionRoles.BUYER.label }}
    </div>
    <div v-else-if="auction.role === auctionRoles.WINNER.value">
      <v-icon color="gold">lens</v-icon> {{ auctionRoles.WINNER.label }}
    </div>
    <div v-else-if="auction.role === auctionRoles.ABANDON.value">
      <v-icon color="grey">lens</v-icon> {{ auctionRoles.ABANDON.label }}
    </div>
    <div v-else-if="auction.role === auctionRoles.DISQUALIFIED.value">
      <v-icon color="red">lens</v-icon> {{ auctionRoles.DISQUALIFIED.label }}
    </div>
    <div v-else-if="auction.role === auctionRoles.LISTING_AGENT.value">
      <v-icon color="cyan">lens</v-icon> {{ auctionRoles.LISTING_AGENT.label }}
    </div>
    <div v-else-if="auction.role === auctionRoles.SELLING_AGENT.value">
      <v-icon color="purple">lens</v-icon> {{ auctionRoles.SELLING_AGENT.label }}
    </div>
    <div v-else><v-icon color="black">lens</v-icon> {{ auction.role }}</div>
  </div>
</template>

<script>
  import { auctionRoles } from '../../utils/PfxUtils.js'
  export default {
    name: 'AuctionRoleStatusIndicator',
    props: {
      auction: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        auctionRoles
      }
    }
  }
</script>

<style  lang="scss" scoped>

  .auction-role-container {
    i { font-size: .8rem; } // custom size for v-icon
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/AuctionRoleStatusIndicator.vue